/* 100X Equine Gut X buy box + gallery behaviors.
   Ported from the inline React App (Gut X PDP.html) to vanilla JS.
   Prices come from data attributes rendered by Liquid (live variant +
   selling-plan-allocation prices, in cents). No React, no Babel. */
(function () {
  var root = document.querySelector('[data-gx-buybox]');
  if (!root) return;

  var money = function (cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  };

  var state = { tier: '1', cadence: '90', mode: 'one' };  // default: one-time, 1 gallon (lowest-friction entry; subscribe is the upsell)

  var sizeBtns = root.querySelectorAll('[data-gx-size] button');
  var cadenceBtns = root.querySelectorAll('[data-gx-cadence] button');
  var modeLabels = root.querySelectorAll('[data-gx-mode]');

  function activeTierBtn() {
    return root.querySelector('[data-gx-size] button[data-tier="' + state.tier + '"]');
  }
  function tier1OneTime() {
    var b = root.querySelector('[data-gx-size] button[data-tier="1"]');
    return b ? Number(b.getAttribute('data-onetime')) : 0;
  }

  function subPrice(btn) {
    var key = 'data-sub' + state.cadence;
    var v = btn.getAttribute(key);
    if (v == null) v = btn.getAttribute('data-sub90');
    return Number(v || 0);
  }

  function qtyLineSub(tier, name) {
    if (tier === '1') return '1 Gallon of Amino-MAX + 1 pump';
    if (tier === '2') return '2 Gallons of Amino-MAX + 2 pumps';
    return '4 Gallons of Amino-MAX + 2 pumps';
  }
  function qtyLineOne(tier) {
    if (tier === '1') return 'Up to 4 month supply for 1 gallon (1 gallon included + 1 pump)';
    if (tier === '2') return 'Up to 4 month supply per gallon (2 Gallons included + 2 pumps)';
    return 'Up to 4 month supply per gallon (4 Gallons included + 2 pumps)';
  }

  var $ = function (sel) { return root.querySelector(sel); };

  function render() {
    var btn = activeTierBtn();
    if (!btn) return;
    var name = btn.getAttribute('data-name');
    var oneTime = Number(btn.getAttribute('data-onetime'));
    var oneStrike = Number(btn.getAttribute('data-onetime-strike') || 0);
    var strike = Number(btn.getAttribute('data-strike') || 0);
    var sub = subPrice(btn);
    var badge = btn.getAttribute('data-badge');
    var bonus = btn.getAttribute('data-bonus');
    var tierQty = Number(state.tier);

    // Subscribe savings badge = savings vs the same gallons at 1-gallon retail.
    var t1 = tier1OneTime();
    var pct = t1 ? Math.round((1 - (sub / tierQty) / t1) * 100) : 0;
    var badgeEl = $('[data-gx-mode-badge]');
    if (badgeEl) badgeEl.textContent = 'Save ' + pct + '%';

    // Mode prices
    $('[data-gx-mode-sub-now]').textContent = money(sub);
    var subStrikeEl = $('[data-gx-mode-sub-strike]');
    subStrikeEl.textContent = strike ? money(strike) : '';
    subStrikeEl.style.display = strike ? '' : 'none';
    $('[data-gx-mode-one-now]').textContent = money(oneTime);
    var oneStrikeEl = $('[data-gx-mode-one-strike]');
    oneStrikeEl.textContent = oneStrike ? money(oneStrike) : '';
    oneStrikeEl.style.display = oneStrike ? '' : 'none';

    // Mode selected state
    modeLabels.forEach(function (l) {
      l.setAttribute('data-on', l.getAttribute('data-gx-mode') === state.mode ? 'true' : 'false');
    });

    // Size seg selected + save labels (save shows in sub mode only)
    sizeBtns.forEach(function (b) {
      b.setAttribute('data-on', b.getAttribute('data-tier') === state.tier ? 'true' : 'false');
      var save = b.querySelector('[data-gx-save]');
      if (save) {
        save.style.display = state.mode === 'sub' ? '' : 'none';
        save.textContent = 'Save ' + money(b.getAttribute('data-save'));
      }
    });
    $('[data-gx-size-label]').innerHTML = '&middot; ' + name;

    // Cadence field only in sub mode
    var cadField = $('[data-gx-cadence-field]');
    cadField.style.display = state.mode === 'sub' ? '' : 'none';
    cadenceBtns.forEach(function (b) {
      b.setAttribute('data-on', b.getAttribute('data-cadence') === state.cadence ? 'true' : 'false');
    });
    $('[data-gx-cadence-label]').innerHTML = '&middot; every ' + state.cadence + ' days';

    // CTA
    var price = state.mode === 'sub' ? sub : oneTime;
    $('[data-gx-cta-label]').textContent = state.mode === 'sub' ? 'Subscribe & Save' : 'Add to Cart';
    $('[data-gx-cta-price]').textContent = money(price);

    // pause/cancel reassure line only in sub
    var subOnly = $('[data-gx-sub-only]');
    if (subOnly) subOnly.style.display = state.mode === 'sub' ? '' : 'none';

    // Includes blocks
    $('[data-gx-included-sub]').style.display = state.mode === 'sub' ? '' : 'none';
    $('[data-gx-included-one]').style.display = state.mode === 'one' ? '' : 'none';
    $('[data-gx-inc-name]').textContent = name;
    $('[data-gx-inc-qty]').textContent = qtyLineSub(state.tier, name);
    $('[data-gx-inc-one-qty]').textContent = qtyLineOne(state.tier);
    // Amino-MAX: tiers WITH a bonus show the bonus line; tiers WITHOUT one (the 1-gal default)
    // show "Free Equine Nutritionist Consultation" instead. Exactly one of the two ever shows.
    var bonusLi = $('[data-gx-inc-bonus-li]');
    var nutriLi = $('[data-gx-inc-nutritionist]');
    if (bonus) {
      bonusLi.style.display = '';
      $('[data-gx-inc-bonus]').innerHTML = bonus;
      if (nutriLi) nutriLi.style.display = 'none';
    } else {
      bonusLi.style.display = 'none';
      if (nutriLi) nutriLi.style.display = '';
    }

    // Mobile bar
    $('[data-gx-mbb-mode]').innerHTML = 'Amino-MAX &middot; ' + name;
    $('[data-gx-mbb-now]').textContent = money(price);
    var mbbStrike = $('[data-gx-mbb-strike]');
    mbbStrike.textContent = (state.mode === 'sub' && strike) ? money(strike) : '';
    mbbStrike.style.display = (state.mode === 'sub' && strike) ? '' : 'none';
    $('[data-gx-mbb-cta]').textContent = state.mode === 'sub' ? 'Subscribe & Save' : 'Add to Cart';
  }

  // ----- events -----
  sizeBtns.forEach(function (b) {
    b.addEventListener('click', function () { state.tier = b.getAttribute('data-tier'); render(); notifyGallery(); });
  });
  cadenceBtns.forEach(function (b) {
    b.addEventListener('click', function () { state.cadence = b.getAttribute('data-cadence'); render(); });
  });
  modeLabels.forEach(function (l) {
    l.addEventListener('click', function () { state.mode = l.getAttribute('data-gx-mode'); render(); });
  });
  var switchSub = $('[data-gx-switch-sub]');
  if (switchSub) switchSub.addEventListener('click', function () { state.mode = 'sub'; render(); });

  // ----- add to cart -----
  var plans = {};
  try { plans = JSON.parse(root.getAttribute('data-plans') || '{}'); } catch (e) {}

  // Current selection, read by the OCU slide-cart bridge (assets/gx-ocu-bridge.js). OCU does
  // the actual add when it is installed, so it needs the variant + plan selected right now.
  window.GX_GET_SELECTION = function () {
    var b = activeTierBtn();
    if (!b) return null;
    return {
      variantId: b.getAttribute('data-variant-id'),
      sellingPlanId: state.mode === 'sub' ? (plans[state.cadence] || null) : null
    };
  };

  function addToCart() {
    var btn = activeTierBtn();
    var variantId = btn.getAttribute('data-variant-id');
    var sellingPlan = state.mode === 'sub' ? plans[state.cadence] : null;
    // Let the cart module (bundle drawer) handle it if present.
    window.dispatchEvent(new CustomEvent('gx:add-to-cart', { detail: {
      items: { 'amino-max': Number(state.tier) },
      variantId: variantId, sellingPlanId: sellingPlan,
      label: btn.getAttribute('data-name') + ' Amino-MAX', mode: state.mode, cadence: state.cadence
    } }));
    // Fallback direct add until the cart drawer module is wired.
    if (!window.__gxCartModule) {
      var line = { id: Number(variantId), quantity: 1 };
      if (sellingPlan) line.selling_plan = Number(sellingPlan);
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [line] })
      }).then(function (r) { return r.json(); }).then(function () {
        window.location.href = '/cart';   // safety net: never leave an add with no feedback
      }).catch(function () {});
    }
  }
  root.querySelectorAll('[data-gx-add-cta]').forEach(function (b) {
    b.addEventListener('click', addToCart);
  });

  // ----- gallery -----
  var mainImg = $('[data-gx-main-img]');
  var mainLabel = $('[data-gx-main-label]');
  var overlay = $('[data-gx-review-overlay]');
  var thumbs = root.querySelectorAll('[data-gx-gallery] .thumb');
  // Guarded: Amino-MAX ships a drop-in image-slot gallery (no photography yet), so there is no
  // data-gx-main-img to swap. Skip the img-swap wiring when it is absent; restore real thumbs +
  // this behavior once Amino photos land (main <img data-gx-main-img> + thumbs with data-src).
  if (mainImg) {
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.setAttribute('data-on', 'false'); });
        t.setAttribute('data-on', 'true');
        mainImg.src = t.getAttribute('data-src');
        var hide = t.getAttribute('data-hidelabel') === 'true';
        if (mainLabel) { mainLabel.style.display = hide ? 'none' : ''; mainLabel.textContent = t.getAttribute('data-label'); }
        if (overlay) overlay.style.display = i === 0 ? '' : 'none';
      });
    });
  }
  function notifyGallery() { /* tier-driven gallery swap hook, reserved */ }

  // ----- common questions accordion -----
  var cq = $('[data-gx-cq]');
  if (cq) {
    cq.querySelectorAll('.gx-cq-item').forEach(function (item) {
      var q = item.querySelector('.gx-cq-q');
      var a = item.querySelector('.gx-cq-a');
      q.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        cq.querySelectorAll('.gx-cq-item').forEach(function (o) {
          o.setAttribute('data-open', 'false');
          o.querySelector('.gx-cq-q').setAttribute('aria-expanded', 'false');
          o.querySelector('.gx-cq-a').style.maxHeight = '0';
        });
        if (!isOpen) {
          item.setAttribute('data-open', 'true');
          q.setAttribute('aria-expanded', 'true');
          a.style.maxHeight = '520px';
        }
      });
    });
    // Mobile: relocate CQ below the buy box; desktop: keep under gallery.
    var galleryCol = root.querySelector('.gallery-col');
    var mq = window.matchMedia('(max-width: 1024px)');
    var placeCQ = function () {
      if (mq.matches) { root.appendChild(cq); }
      else if (galleryCol && cq.parentElement !== galleryCol) { galleryCol.appendChild(cq); }
    };
    placeCQ();
    mq.addEventListener('change', placeCQ);
  }

  // ----- sticky mobile buy bar -----
  var cta = root.querySelector('.add-cta');
  var mbar = $('[data-gx-mobile-bar]');
  if (cta && mbar && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      mbar.setAttribute('data-show', entries[0].isIntersecting ? 'false' : 'true');
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    io.observe(cta);
  }

  // ----- ship-by countdown (next 3pm CT) + ZIP transit -----
  var shipLine = $('[data-gx-ship-line]');
  var zipInput = $('[data-gx-ship-zip]');
  var zipOk = $('[data-gx-ship-ok]');
  function zipTransit(z) {
    if (!/^\d{5}$/.test(z)) return 3;
    return ({ '7': 2, '6': 2, '4': 3, '5': 3, '3': 3, '2': 4, '8': 4, '0': 4, '1': 4, '9': 5 })[z[0]] || 3;
  }
  var isBiz = function (d) { return d.getDay() >= 1 && d.getDay() <= 5; };
  var addBiz = function (date, n) { var d = new Date(date); while (n > 0) { d.setDate(d.getDate() + 1); if (isBiz(d)) n--; } return d; };
  function renderShip() {
    if (!shipLine) return;
    var zip = zipInput ? zipInput.value : '';
    var days = zipTransit(zip);
    var c = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
    var cutoff = new Date(c); cutoff.setHours(15, 0, 0, 0);
    if (c >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
    var todays3pm = new Date(c); todays3pm.setHours(15, 0, 0, 0);
    var shipDate = (isBiz(c) && c < todays3pm) ? new Date(c) : addBiz(c, 1);
    var delivery = addBiz(shipDate, days);
    // Round-3: emit BOTH date forms; CSS shows dd-full on desktop and dd-short (short) on phones,
    // so line 1 of the two-line split fits. The dd-full/dd-short CSS already existed but the JS
    // never emitted the spans, so mobile had been showing the long date.
    var dFull = delivery.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
    var dShort = delivery.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    var dStr = '<span class="dd-full">' + dFull + '</span><span class="dd-short">' + dShort + '</span>';
    var ms = cutoff - c;
    var h = Math.floor(ms / 3600000); ms -= h * 3600000;
    var m = Math.floor(ms / 60000);
    var countdown = (h > 0 ? h + (h === 1 ? ' hr ' : ' hrs ') : '') + m + (m === 1 ? ' min' : ' mins');
    // Round-4: verbose countdown on desktop (dd-full), COMPACT on mobile (dd-short) so the one-line
    // delivery fits phones ("16h 8m" not "16 hrs 8 mins"). Matches the design source (both forms in
    // dd spans, toggled by the same .ship-cutoff .dd-full/.dd-short rules as the date).
    var countdownShort = (h > 0 ? h + 'h ' : '') + m + 'm';
    var cStr = '<span class="dd-full">' + countdown + '</span><span class="dd-short">' + countdownShort + '</span>';
    // sc-a/sc-b spans stay inline (round-4 reverted the block split); they are the wrap points for the <=340 guard.
    shipLine.innerHTML = '<span class="sc-a">FREE delivery <strong>' + dStr + '</strong>.</span> <span class="sc-b">Order within <strong class="sc-count">' + cStr + '</strong></span>';
  }
  if (zipInput) {
    try { zipInput.value = localStorage.getItem('gx_zip') || ''; } catch (e) {}
    // Match the design's inline width: 128px while empty (fits "Enter Zip to Confirm"),
    // then (length + 0.5)ch once digits are typed so the underline tracks the value.
    var sizeZip = function () { zipInput.style.width = zipInput.value ? (zipInput.value.length + 0.5) + 'ch' : '128px'; };
    sizeZip();
    zipInput.addEventListener('input', function () {
      zipInput.value = zipInput.value.replace(/\D/g, '').slice(0, 5);
      sizeZip();
      var ok = /^\d{5}$/.test(zipInput.value);
      if (zipOk) zipOk.style.display = ok ? '' : 'none';
      try { if (ok) localStorage.setItem('gx_zip', zipInput.value); } catch (e) {}
      renderShip();
    });
    if (/^\d{5}$/.test(zipInput.value) && zipOk) zipOk.style.display = '';
  }
  renderShip();
  setInterval(renderShip, 30000);

  render();
})();
